import { appDashboardDataSource } from '../../appDataSource'
import { useAgentBuilderCatalogQuery, useAgentBuilderDashboardQuery } from '../../hooks'
import { useDashboardView, type DatePresetOptionsResult, type UseDashboardViewArgs } from './useDashboardView'

function useCatalogDatePresetOptions(clientId: string, platformTypeId: number): DatePresetOptionsResult {
  const catalogQuery = useAgentBuilderCatalogQuery(clientId, platformTypeId)
  return { data: catalogQuery.data?.datePresetOptions, isLoading: catalogQuery.isLoading }
}

/** The app's viewer engine: the API for data, and React Query for the saved dashboard and catalog. */
export function useDashboardViewEngine(
  args: Omit<UseDashboardViewArgs, 'dataSource' | 'useSavedDashboard' | 'useDatePresetOptions'>,
) {
  return useDashboardView({
    ...args,
    dataSource: appDashboardDataSource,
    useSavedDashboard: useAgentBuilderDashboardQuery,
    useDatePresetOptions: useCatalogDatePresetOptions,
  })
}
